module.exports = __webpack_public_path__ + "img/img_level_13.6ebb7648.png";